import { createIcon } from '@chakra-ui/icons';

export const Expand = createIcon({
  displayName: 'Expand',
  viewBox: '0 0 24 24',
  d: 'M10.3594 11.8594L12.1406 13.625L4.26562 21.5H11.5V24H0V12.5H2.5V19.7344L10.3594 11.8594ZM12.5 0H24V11.5H21.5V4.26562L13.6406 12.1406L11.8594 10.3594L19.7344 2.5H12.5V0Z',
});
